module.exports = __webpack_public_path__ + "media/images/responsive/flow/sola_online_step_04-559c7e899c988db0785792754458c093.jpg";